/**
 * Configuración de Marca Blanca (White Label)
 *
 * Este archivo define la configuración por dominio para ocultar/mostrar
 * elementos de la interfaz según el cliente.
 *
 * Para agregar un nuevo dominio de marca blanca:
 * 1. Agregar una nueva entrada en WHITELABEL_DOMAINS con el dominio como key
 * 2. Configurar las opciones según las necesidades del cliente
 */

// Dominios que pertenecen a CitoPlus (NO son marca blanca)
const CITOPLUS_DOMAINS = [
  "soy.citoplus.com",
  "citoplus.com",
  "www.citoplus.com",
  "127.0.0.1",
];

// Configuración específica por dominio de marca blanca
const WHITELABEL_DOMAINS = {
  "admin.citofonovirtual.com": {
    brandName: "Citófono Virtual",
    // Logo personalizado (null = usa logo genérico, string = URL del logo)
    logo: null,
    logoWhite: null,
    // Secciones del menú a ocultar (por título exacto del menú)
    hiddenMenuItems: [],
    // Ocultar submenús específicos (formato: "MenuPadre.SubMenu")
    hiddenSubMenuItems: [],
    // Componentes del dashboard a ocultar
    hiddenDashboardComponents: ["PreRegistroVisitantesQR"],
  },
  "dev.citofonovirtual.com": {
    brandName: "Citófono Virtual",
    // Logo personalizado (null = usa logo genérico, string = URL del logo)
    logo: null,
    logoWhite: null,
    // Secciones del menú a ocultar (por título exacto del menú)
    hiddenMenuItems: [],
    // Ocultar submenús específicos (formato: "MenuPadre.SubMenu")
    hiddenSubMenuItems: [],
    // Componentes del dashboard a ocultar
    hiddenDashboardComponents: ["PreRegistroVisitantesQR"],
  },
  "127.0.0.1": {
    brandName: "Citófono Virtual",
    logo: null,
    logoWhite: null,
    hiddenMenuItems: [],
    hiddenSubMenuItems: [],
    hiddenDashboardComponents: ["PreRegistroVisitantesQR"],
  },
  // Ejemplo de otro cliente:
  // "admin.otroclient.com": {
  //   brandName: "Otro Cliente",
  //   logo: "/path/to/logo.png",
  //   logoWhite: "/path/to/logo-white.png",
  //   hiddenMenuItems: ["Citófonos", "Mensajería"],
  //   hiddenSubMenuItems: ["Mi cuenta.Pagos", "Mi cuenta.Contratos"],
  //   hiddenDashboardComponents: ["PreRegistroVisitantesQR", "WhatsAppQRDashboard"],
  // },
};

/**
 * Detecta si el dominio actual es marca blanca
 */
const isCitoplusDomain = (hostname) => {
  return CITOPLUS_DOMAINS.some(
    (domain) => hostname === domain || hostname.endsWith(`.${domain}`),
  );
};

/**
 * Obtiene la configuración de marca blanca para el dominio actual
 */
export const getWhiteLabelConfig = () => {
  const hostname = window.location.hostname;

  // Si es un dominio de CitoPlus, retornar configuración normal
  if (isCitoplusDomain(hostname)) {
    return {
      isWhiteLabel: false,
      brandName: "CitoPlus",
      logo: null,
      logoWhite: null,
      hiddenMenuItems: [],
      hiddenSubMenuItems: [],
      hiddenDashboardComponents: [],
      showBranding: true,
    };
  }

  // Buscar configuración específica del dominio
  const domainConfig = WHITELABEL_DOMAINS[hostname];

  if (domainConfig) {
    return {
      isWhiteLabel: true,
      showBranding: false,
      hiddenDashboardComponents: [],
      ...domainConfig,
    };
  }

  // Dominio desconocido: aplicar configuración de marca blanca por defecto
  return {
    isWhiteLabel: true,
    brandName: null,
    logo: null,
    logoWhite: null,
    hiddenMenuItems: [],
    hiddenSubMenuItems: [],
    hiddenDashboardComponents: [],
    showBranding: false,
  };
};

/**
 * Verifica si un item del menú debe ocultarse
 */
export const shouldHideMenuItem = (config, menuTitle, parentTitle = null) => {
  if (!config.isWhiteLabel) return false;

  // Verificar si el menú principal está oculto
  if (config.hiddenMenuItems.includes(menuTitle)) {
    return true;
  }

  // Verificar si es un submenú oculto
  if (parentTitle) {
    const subMenuKey = `${parentTitle}.${menuTitle}`;
    if (config.hiddenSubMenuItems.includes(subMenuKey)) {
      return true;
    }
  }

  return false;
};

/**
 * Verifica si un componente del dashboard debe ocultarse
 */
export const shouldHideDashboardComponent = (config, componentName) => {
  if (!config.isWhiteLabel) return false;
  return config.hiddenDashboardComponents.includes(componentName);
};

export default {
  getWhiteLabelConfig,
  shouldHideMenuItem,
  shouldHideDashboardComponent,
  CITOPLUS_DOMAINS,
  WHITELABEL_DOMAINS,
};
